import { useDispatch } from 'react-redux'
import { useCallback, useMemo } from 'react'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { questionsThunks } from '@ucheba/store/questions'
import { useRouter } from 'next/router'
import { feedbacksThunks } from '@ucheba/store/feedbacks'
import { EInstitutionType, IInstitutionType } from '@ucheba/store/institutions/item/types'

interface IFormType {
  type: 'feedbacks' | 'questions'
}

export interface ICommentsAndFeedbacksCore {
  (props: IFormType): {
    offset: number
    onAfterSubmit: () => void
    limit: number
  }
}

export const useCommentsAndFeedbacksRequestCore: ICommentsAndFeedbacksCore = (props) => {
  const { type } = props

  const { push, asPath, query } = useRouter()

  const dispatch = useDispatch()

  const limit = 20

  const offset = useMemo(() => {
    const page = Number(query.page) || 1
    return 20 * page - 20
  }, [query.page])

  const onAfterSubmit = useCallback(() => {
    push(stringifyUrl(asPath, { update: { ...query }, exclude: ['page'] }), undefined, {
      shallow: true,
    })
    switch (type) {
      case 'questions':
        dispatch(
          questionsThunks.fetch({
            data: { id: query.id, limit: 20, type: 'institution', offset: 0 },
          })
        )
        break
      case 'feedbacks':
        dispatch(
          feedbacksThunks.fetch({
            data: { id: query.id, limit: 20, type: 'institution', offset: 0 },
          })
        )
        break
      default:
    }
  }, [asPath, dispatch, push, query, type])
  return {
    offset,
    onAfterSubmit,
    limit,
  }
}

export const getDescription = (
  abbreviation?: string | null,
  name?: string,
  type?: IInstitutionType
): string => {
  let typeName = ''

  const nameUZ = abbreviation || name || ''

  if (type) {
    if (type.value === EInstitutionType.University) {
      typeName = 'о вузе'
    }

    if (type.value === EInstitutionType.College) {
      typeName = 'о колледже'
    }

    if (type.value === EInstitutionType.TrainingCenter) {
      typeName = 'об учебной центре'
    }

    if (type.value === EInstitutionType.MBA) {
      typeName = 'об MBA'
    }

    if (type.value === EInstitutionType.School) {
      typeName = 'о школе'
    }

    if (type.value === EInstitutionType.ChildrenCourses) {
      typeName = 'о детском учебной центре'
    }

    if (type.value === EInstitutionType.Kindergarten) {
      typeName = 'о детском саде'
    }

    if (type.value === EInstitutionType.Agency) {
      typeName = 'об агенстве'
    }
  }

  return `Вся информация ${typeName} ${nameUZ} — программы, варианты и стоимость обучения, условия поступления и отзывы.`
}
